/**
 * @generated SignedSource<<97a190270781beb8f4c7c7598ef8ea10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type KPIStoreAnalytics_KPI$data = {
  readonly id: string;
  readonly sectionAggregates: ReadonlyArray<{
    readonly results: ReadonlyArray<{
      readonly date: string;
      readonly value: number;
    }>;
    readonly section: {
      readonly assignedTeam: {
        readonly color: string | null;
        readonly icon: TeamIcon | null;
        readonly name: string;
      } | null;
      readonly id: string;
      readonly title: string | null;
    };
  } | null>;
  readonly title: string;
  readonly unit: NumberTaskUnit;
  readonly " $fragmentType": "KPIStoreAnalytics_KPI";
};
export type KPIStoreAnalytics_KPI$key = {
  readonly " $data"?: KPIStoreAnalytics_KPI$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIStoreAnalytics_KPI">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPIStoreAnalytics_KPI",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "KPISectionAggregate",
      "kind": "LinkedField",
      "name": "sectionAggregates",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSection",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "assignedTeam",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "icon",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "color",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "KPIAggregateResult",
          "kind": "LinkedField",
          "name": "results",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "KPI",
  "abstractKey": null
};
})();

(node as any).hash = "4cd17e90d9ad7ea8b7408d7c5ab4e6d9";

export default node;
